<template>
  <div id="app">
    <router-view />
    <notifications group="foo" position="bottom right" />
    <notifications group="bar" position="bottom left" />
  </div>
</template>
<script>
import Loading from "@/components/Loading";
export default {
  components: {
    Loading
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css?family=Montserrat:400,500,600,700,800,900&display=swap');

$theme-color: #285c4d;
$default-color: #293135;
$accent-color: #fff;
$secondary-color: #999944;
$red-color: #9d2449;

.theme-text {
  color: $theme-color !important;
}

.default-text {
  color: $default-color !important;
}
.red-text {
  color: $red-color !important;
}
.accent-text {
  color: $accent-color !important;
}
.secondary-text {
  color: $secondary-color !important;
}


.bold {
  font-weight: 700;
}

.bolder {
  font-weight: 800;
}

.smaller {
  font-size: 0.65rem;
}

.small {
  font-size: 0.8rem;
}

.large {
  font-size: 1.09rem;
}

.larger {
  font-size: 1.8rem;
}

.uppercase {
  text-transform: uppercase;
}

#app {
  font-family: 'Montserrat', sans-serif;
 }
 .form-title {
    color: #13322b;
    font-size: 2.5rem;
    margin:0;
  }
  .form-subtitle {
    color: #285c4d;
    font-size: 1rem;
  }
  .down {
      height: 5vh;
      width: 5vh;
    }

@media (max-width: 767px) {
  .form-title {
      font-size: 2rem;
    }
  .form-subtitle {
    font-size: 0.6rem;
  }
}

</style>
